/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * snippets/request-part-form.liquid: right before the visible "contact" form does its normal
 * native submit (full page reload, existing form.posted_successfully?/errors handling), fire a
 * background request to also create a real Shopify Customer from the same name/email, so the
 * lead is queryable in Admin > Clientes. Fire-and-forget on purpose: customer-creation errors
 * (e.g. duplicate email) shouldn't block or confuse someone who's just reporting a missing part.
 */
document.addEventListener('submit', function (event) {
  var contactForm = event.target.closest('#request-part-contact-form');

  if (!contactForm) {
    return;
  }

  var customerForm = document.getElementById('request-part-customer-form');

  if (!customerForm) {
    return;
  }

  var name = contactForm.querySelector('[name="contact[name]"]').value;
  var email = contactForm.querySelector('[name="contact[email]"]').value;
  var randomPassword = 'CSP-' + Math.random().toString(36).slice(2, 10) + Date.now();

  customerForm.querySelector('[name="customer[first_name]"]').value = name;
  customerForm.querySelector('[name="customer[email]"]').value = email;
  customerForm.querySelector('[name="customer[password]"]').value = randomPassword;

  fetch(customerForm.action, {
    method: 'POST',
    body: new FormData(customerForm),
    credentials: 'same-origin',
    keepalive: true
  }).catch(function () {});
});

/**
 * sections/catalog-explainer.liquid: uppercase the hero search field as the shopper
 * types, matching the reference "hero_autopecas_leve" package (part codes read as
 * BOS-48210, not bos-48210).
 */
document.addEventListener('input', function (event) {
  if (!event.target.matches('[data-catalog-hero-uppercase]')) {
    return;
  }

  var input = event.target;
  var cursorPosition = input.selectionStart;

  input.value = input.value.toUpperCase();
  input.setSelectionRange(cursorPosition, cursorPosition);
});

/**
 * sections/catalog-explainer.liquid: click-to-play the hero's YouTube/Vimeo embed
 * instead of loading it eagerly. Mirrors assets/theme.js's VideoSection (_playVideo:
 * swap the iframe's data-src into src, mark the frame as playing) -- that class only
 * auto-attaches for section type "video" though, so this hero (a different section
 * type) needs its own delegated listener here.
 */
document.addEventListener('click', function (event) {
  var frame = event.target.closest('[data-catalog-hero-play-video]');

  if (!frame || frame.classList.contains('is-playing')) {
    return;
  }

  var iframe = frame.querySelector('iframe');

  if (!iframe) {
    return;
  }

  iframe.src = iframe.getAttribute('data-src');
  frame.classList.add('is-playing');
});

/**
 * snippets/product-gallery.liquid: draw the product's photo onto a <canvas> with the
 * merchant's watermark_image tiled diagonally across it, instead of a plain <img>, so
 * there's no clean image sitting in the DOM to drag or right-click "Save image as" --
 * this is what the customer's browser saves instead. Runs once per canvas found on the
 * page (custom.js loads with `defer`, so the DOM is already parsed by the time this
 * runs -- no need to wait for DOMContentLoaded).
 */
function drawWatermarkedProductImage(canvas) {
  var imageSrc = canvas.getAttribute('data-image-src');
  var watermarkSrc = canvas.getAttribute('data-watermark-src');
  var opacity = parseFloat(canvas.getAttribute('data-watermark-opacity')) || 0.3;

  if (!imageSrc || !watermarkSrc) {
    return;
  }

  var productImage = new Image();
  productImage.crossOrigin = 'anonymous';

  productImage.onload = function () {
    canvas.width = productImage.naturalWidth;
    canvas.height = productImage.naturalHeight;

    var ctx = canvas.getContext('2d');
    ctx.drawImage(productImage, 0, 0);

    var watermarkImage = new Image();
    watermarkImage.crossOrigin = 'anonymous';

    watermarkImage.onload = function () {
      var tileSize = Math.max(canvas.width, canvas.height) * 0.22;
      var scale = tileSize / Math.max(watermarkImage.naturalWidth, watermarkImage.naturalHeight);
      var tileWidth = watermarkImage.naturalWidth * scale;
      var tileHeight = watermarkImage.naturalHeight * scale;
      var stepX = tileWidth * 1.8;
      var stepY = tileHeight * 1.8;
      var diagonal = Math.sqrt((canvas.width * canvas.width) + (canvas.height * canvas.height));

      ctx.save();
      ctx.globalAlpha = opacity;
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((-25 * Math.PI) / 180);
      ctx.translate(-canvas.width / 2, -canvas.height / 2);

      for (var y = -diagonal; y < diagonal; y += stepY) {
        for (var x = -diagonal; x < diagonal; x += stepX) {
          ctx.drawImage(watermarkImage, x, y, tileWidth, tileHeight);
        }
      }

      ctx.restore();
      canvas.classList.add('lazyloaded');
    };

    watermarkImage.src = watermarkSrc;
  };

  productImage.src = imageSrc;
}

function initWatermarkedProductImages() {
  document.querySelectorAll('[data-watermarked-product-image]:not([data-watermark-initialized])').forEach(function (canvas) {
    canvas.setAttribute('data-watermark-initialized', 'true');
    drawWatermarkedProductImage(canvas);
  });
}

initWatermarkedProductImages();

// Quick view loads its product section over fetch() straight into the modal's DOM
// (assets/theme.js _openQuickView), well after this script's initial pass above --
// re-scan on any DOM change instead of hooking a quick-view-specific event.
new MutationObserver(initWatermarkedProductImages).observe(document.body, { childList: true, subtree: true });